var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('div',{staticClass:"AppPage",attrs:{"id":"app"}},[(_vm.showHeader)?_c('app-header',{attrs:{"mobile":_vm.mobile}}):_vm._e(),_c('div',{class:{ main: _vm.showHeader }},[_c('router-view')],1),(_vm.showFooter)?_c('app-footer'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }